export default "mutation UpdateBirthdate($birthdate:String!){data:updateBirthdate(birthdate:$birthdate){birthDate}}"